import Vue from "vue";
import Router from "vue-router";
import Layout from "@/components/layout";
import Data from "@/components/data/dataIndex";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  mode: "history",
  base: "/",
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: () => import(/* webpackChunkName: 'Login' */ '@/components/login.vue')
    // },
    {
      path: "/login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: 'Login' */ "@/components/login.vue")
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: () =>
        import(/* webpackChunkName: 'Login' */ "@/components/pricing.vue")
    },
    {
      path: "/pay/:id",
      name: "Pay",
      component: () =>
        import(/* webpackChunkName: Pricing */ "@/components/pay.vue")
    },
    {
      path: "/link",
      name: "Link",
      component: () =>
        import(/* webpackChunkName: 'yApp' */ "@/components/link.vue")
    },
    {
      path: "/apply",
      meta: { requireAuth: true },
      name: "Apply",
      component: () =>
        import(/* webpackChunkName: 'Apply' */ "@/components/apply.vue")
    },
    {
      path: "/user",
      name: "User",
      component: () =>
        import(/* webpackChunkName: User */ "@/components/user.vue")
    },
    {
      path: "/home",
      name: "Home",
      component: () =>
        import(/* webpackChunkName: User */ "@/components/home.vue")
    },

    {
      path: "/",
      component: Layout,
      redirect: "/home",
      children: [
        {
          path: "/index",
          name: "Index",
          meta: { requireAuth: true },
          component: () =>
            import(/* webpackChunkName: 'Index' */ "@/components/index.vue")
        },
        {
          path: "/app",
          // meta: { requireAuth: true },
          name: "App",
          component: () =>
            import(/* webpackChunkName: 'yApp' */ "@/components/app.vue")
        },
        {
          path: "/commission",
          meta: { requireAuth: true },
          name: "Commission",
          component: () =>
            import(
              /* webpackChunkName: 'Commission' */ "@/components/commission.vue"
            )
        },
        {
          path: "/addExperiment",
          meta: { requireAuth: true },
          name: "addExperiment",
          component: () =>
            import(
              /* webpackChunkName: 'addExperiment' */ "@/components/addExperiment.vue"
            )
        },
        {
          path: "/data",
          component: Data,
          redirect: "/data/meta",
          children: [
            {
              path: "/data/meta",
              meta: { requireAuth: true },
              name: "metaData",
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/metaData.vue"
                )
            },
            {
              path: "/data/join",
              meta: { requireAuth: true },
              name: "Join",
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/join.vue"
                )
            },
            {
              path: "/data/message",
              meta: { requireAuth: true },
              name: "Message",
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/message.vue"
                )
            },
            {
              path: "/data/information",
              name: "Information",
              meta: { requireAuth: true },
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/data.vue"
                )
            },
            {
              path: "/data/dashboard",
              meta: { requireAuth: true },
              name: "Dashboard",
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/dashboard.vue"
                )
            },
            {
              path: "/data/detail",
              meta: { requireAuth: true },
              name: "dataDetail",
              component: () =>
                import(
                  /* webpackChunkName: 'Data' */ "@/components/data/dataDetail.vue"
                )
            }
          ]
        },
        {
          path: "/messageDetail",
          meta: { requireAuth: true },
          name: "messageDetail",
          component: () =>
            import(
              /* webpackChunkName: 'messageDetail' */ "@/components/data/messageDetail.vue"
            )
        },
        {
          path: "/messageAdd",
          meta: { requireAuth: true },
          name: "messageAdd",
          component: () =>
            import(
              /* webpackChunkName: 'messageAdd' */ "@/components/data/messageAdd.vue"
            )
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js